import { render, staticRenderFns } from "./standard-image-display.vue?vue&type=template&id=2d5b6376&scoped=true"
import script from "./standard-image-display.vue?vue&type=script&lang=js"
export * from "./standard-image-display.vue?vue&type=script&lang=js"
import style0 from "./standard-image-display.vue?vue&type=style&index=0&id=2d5b6376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5b6376",
  null
  
)

export default component.exports